module.exports = __webpack_public_path__ + "img/1529862844.3301be8a.jpg";